import { createApp, h } from 'vue';

export function mountComponent(Component, props = {}, globalProperties = {}) {
  const container = document.createElement('div');
  document.body.appendChild(container);

  const app = createApp({
    render() {
      return h(Component, {
        ...props,
        ref: 'component'
      });
    }
  });

  Object.assign(app.config.globalProperties, globalProperties);

  const root = app.mount(container);
  const component = root.$refs.component;
  let mounted = true;

  const unmount = () => {
    if (!mounted) {
      return;
    }

    mounted = false;
    app.unmount();
    container.remove();
  };

  return { app, component, container, unmount };
}
